import React from 'react';
import './myprofilecontent.css'
import defaultimg from '../../../assets/defaultimg.webp';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import MyProfilePortfolio from './myprofileportfolio';
import MyProfileExperience from './myprofileexperience';
import MyProfileEducation from './myprofileeducation';
import MyProfileCertification from './myprofilecertification';
import AddPortfolio from './addportfolio.js';
import AddExperience from './addexperience.js'
import AddEducation from './addeducation';
import AddCertifications from './addcertifications';
import { useEffect } from 'react';
import { getLoginId } from '../../Authentication/AuthSvc/authservice';
import SkillsDropdown from '../../SkillsDropdown/skillsdropdown';
import ThemedProfileGrid from './ThemedProfileGrid';

const API_URL = process.env.REACT_APP_API_URL;

const MyProfileContent = () => {
    const [user, setUser] = useState([]);
    const [expdetails, setExpDetails] = useState([]);
    const [edudetails, setEduDetails] = useState([]);
    const [certdetails, setCertDetails] = useState([]);
    const [selectedrole, setSelectedRole] = useState('');
    const [loading, setLoading] = useState(true);
    const [myprofselection, setMyProfSelection] = useState('portfolio');
    const [profilesave, setProfileSave] = useState(false);
    const { id } = useParams();
    const loginID = getLoginId();
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isPopupOpen, setisPopupOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [isOngoing, setIsOngoing] = useState(false);
    const [error, setError] = useState('');

    const handleFileChange = async (e) => {
        setSelectedFile(e.target.files[0]);
        const reader = new FileReader();
        reader.onload = async () => {
            setPreviewUrl(reader.result);
        };
        reader.readAsDataURL(e.target.files[0]);
    };

    const handleFileUpload = async (e) => {
        setIsUploading(true);
        const formData = new FormData();
        formData.append('image', selectedFile);
        try {
            const response = await fetch(`${API_URL}/profileimageupload/${id}`, {
                method: 'POST',
                body: formData,
            });
        } catch (error) {
            console.log('Error uploading image', error);
        } finally {
            setIsUploading(false);
        }
        fetchUser();
    };

    const openPopup = () => {
        setisPopupOpen(true);
    };

    const closePopup = () => {
        setisPopupOpen(false);
    };

    const toggleProfileSave = () => {
        setProfileSave(!profilesave);
        setTimeout(() => {
            setProfileSave(false);
        }, 3000);
    }

    const handleDeleteSkill = async (skillname) => {
        try {
            const response = await fetch(`${API_URL}/myprofile/${id}/deleteskill`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ deleteskill: skillname })
            });

            if (!response.ok) {
                throw new Error('Failed to delete skill');
            }

        } catch (error) {
            console.error('Error deleting skill:', error);
        }
        fetchUser();
    }

    const handlePortfolioDelete = async (portfolioID) => {
        try {
            const response = await fetch(`${API_URL}/myprofile/${id}/deleteportfolio`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ portfolioID: portfolioID })
            });
        } catch (error) {
            console.error("Error deleting portfolio entry:", error);
        }
        fetchUser();
    }

    const handleExperienceDelete = async (experienceID) => {
        try {
            const response = await fetch(`${API_URL}/myprofile/${id}/deleteexperience`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ experienceID: experienceID })
            });
        } catch (error) {
            console.error("Error deleting experience entry:", error);
        }
        fetchUser();
    }

    const handleEducationDelete = async (educationID) => {
        try {
            const response = await fetch(`${API_URL}/myprofile/${id}/deleteeducation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ educationID: educationID })
            });
        } catch (error) {
            console.error("Error deleting education entry:", error);
        }
        fetchUser();
    }

    const handleCertificationDelete = async (certificationID) => {
        try {
            const response = await fetch(`${API_URL}/myprofile/${id}/deletecertification`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ certificationID })
            });

            if (!response.ok) {
                throw new Error('Failed to delete certification');
            }
            await fetchUser(); // Make sure to await the fetchUser call
        } catch (error) {
            console.error("Error deleting certification entry:", error);
        }
    };
    const handleUpdateInfo = async (event) => {
        event.preventDefault();

        // Retrieve current form values
        const firstname = event.target.firstname.value;
        const lastname = event.target.lastname.value;
        const username = event.target.user.value;
        const email = event.target.email.value;
        const roles = event.target.roles ? event.target.roles.value : null;
        const course = event.target.course ? event.target.course.value : null;
        const year = event.target.year ? event.target.year.value : null;
        const tagline = event.target.tagline ? event.target.tagline.value : null;
        const profiledesc = event.target.profiledesc ? event.target.profiledesc.value : null;

        // Compare current values with user object values
        const isModified = (
            firstname !== user.first_name ||
            lastname !== user.last_name ||
            username !== user.username ||
            email !== user.email ||
            roles !== user.user_type ||
            course !== user.course ||
            year !== user.mat_year ||
            tagline !== user.tagline ||
            profiledesc !== user.description
        );


        // If any value is modified, proceed to update
        if (isModified) {
            try {
                const response = await fetch(`${API_URL}/myprofile/${id}/updateprofile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        firstname,
                        lastname,
                        user: username,
                        email,
                        roles,
                        course,
                        year,
                        tagline,
                        profiledesc
                    })
                });
                const data = await response.json();
                if (!response.ok) {
                    throw new Error(data.error || data.details || 'Failed to update user info');
                }

                // Only fetch user and toggle save message if update was successful
                await fetchUser();
                toggleProfileSave();
            } catch (error) {
                console.error('Error updating:', error);
                // Optionally show error to user via UI

            }
        } else {
            console.log('No changes were made.');
        }
    };

    const handleSkillSubmit = async (event) => {
        event.preventDefault();
        const newSkill = event.target.newskill.value;

        try {
            const response = await fetch(`${API_URL}/myprofile/${id}/addskill`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ newskill: newSkill })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to add skill');
            }

            // Clear the input field
            event.target.newskill.value = '';

            // Fetch updated user data
            await fetchUser();

        } catch (error) {
            console.error('Error adding skill:', error);
            // Optionally show error to user via UI
            alert(error.message);
        }
    }
    const handleRoleChange = (event) => {
        setSelectedRole(event.target.value);
    }
    const handleProfSelection = (selection) => {
        setMyProfSelection(selection);
    }

    const fetchUser = async () => {
        if (!id) return;
        try {
            const response = await fetch(`${API_URL}/myprofile/${id}`);
            const data = await response.json();
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            setUser(data.user_details);
            setExpDetails(data.experience);
            setEduDetails(data.education);
            setCertDetails(data.certification);

            if (data.user_details.user_type === 'student') {
                setSelectedRole('student');
            }
            else if (data.user_details.user_type === 'prof') {
                setSelectedRole('prof');
            }
            else if (data.user_details.user_type === 'staff') {
                setSelectedRole('staff');
            }
        } catch (error) {
            console.error('Error fetching user:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id){
            fetchUser();
        }
    }, [id]);

    const topSkillsArray = user.skill_names ? user.skill_names.split(',').map(skill => skill.trim()).filter(skill => skill !== '') : [];
    const portfolioIDArray = user.portfolio_id ? user.portfolio_id.split(',').map(title => title.trim()) : [];
    const portfolioTitlesArray = user.portfolio_title ? user.portfolio_title.split(',').map(title => title.trim()) : [];
    const portfoliohyperlinksArray = user.portfolio_link ? user.portfolio_link.split(',').map(title => title.trim()) : [];
    const PortfolioImageLinksArray = user.portfolio_image_link ? user.portfolio_image_link.split(',').map(title => title.trim()) : [];

    return (
        <div className='myprofilebody'>
            {loading ? (
                <p>Loading ...</p>
            ) : id === loginID ? (
                <div className="myprofile-container">
                    <div className="myprofile-column1">
                        <form onSubmit={handleUpdateInfo}>
                            <ThemedProfileGrid className="myprofile-grid-1">
                                <div className='profiletitle'>
                                    <h2>My Profile</h2>
                                    <div className='saveprofile'>
                                        <button type="submit" className='myprofsaveBtn' value='send'>Save</button>
                                        {profilesave && (
                                            <span style={{ color: '#09CE78', marginLeft: '1rem' }}>Updated</span>
                                        )}
                                    </div>
                                </div>
                                <hr style={{ margin: '0.8rem 0' }} />
                                <div className='myprofile-bar'>
                                    <div className='myprofiledetails myprofiledetails1'>
                                        <div>
                                            <div>
                                                {user.profile_pic != null ? (
                                                    <img src={user.profile_pic} alt="UIDesign" className='myprofileImg' />
                                                ) : (
                                                    <img src={defaultimg} alt="UIDesign" className='myprofileImg' />
                                                )}
                                                {/* <img src={jason} alt="UIDesign" className='myprofileImg' /> */}
                                            </div>
                                            <div style={{ display: 'flex', marginBottom: '-1rem' }}>
                                                <span style={{ marginRight: '1rem' }}>Image:</span>
                                                <input type="file" onChange={handleFileChange} disabled={isUploading} style={{ paddingTop: '0.2rem', width: '40%' }} />
                                                <button onClick={handleFileUpload} className="uploadBtn" disabled={isUploading}>Upload</button>
                                            </div>
                                        </div>
                                        {/* <div className='ppicons'> */}
                                        {/* <button className='profeditbtn'><i class="fa-solid fa-pen-to-square"></i></button>
                                            <button className='profdelbtn'><i class="fa-solid fa-trash"></i></button> */}
                                        {/* </div> */}
                                    </div>

                                    <div className='myprofiledetails myprofiledetails2'>
                                        <div className='firstlast'>
                                            <input type="text" name="firstname" className='firstnameinput' placeholder='First Name' defaultValue={user.first_name} required />
                                            <input type="text" name="lastname" className='lastnameinput' placeholder='Last Name' defaultValue={user.last_name} required />
                                        </div>
                                        <input type="text" name="user" className='profileinput' placeholder='Username' defaultValue={user.username} />
                                        <input type="text" name="email" className='profileinput' placeholder='Email' defaultValue={user.email} />
                                        <select name="roles" id="roles" className='profileinput' onChange={handleRoleChange} value={selectedrole}>
                                            <option value="" style={{ color: 'white' }}>Select Role</option>
                                            <option value="student">Student</option>
                                            <option value="prof">Professor</option>
                                            <option value="staff">Staff</option>
                                        </select>
                                        {selectedrole === 'student' && (
                                            <div className='courseyear'>
                                                <input type="text" name="course" className='courseinput' placeholder='Course' defaultValue={user.course} />
                                                <select name="year" id="year" className='yearinput' defaultValue={user.mat_year}>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                </select>
                                            </div>
                                        )}

                                        <input type="text" name="tagline" className='profileinput' placeholder='Tagline' defaultValue={user.tagline} />
                                    </div>
                                </div>
                                <hr />
                                <div className='myprofiledesc' style={{ marginTop: '1.5rem' }}>
                                    <textarea name='profiledesc' style={{ resize: 'vertical', maxHeight: '18rem', minHeight: '2.8rem' }} className='profiledesctextarea' placeholder='Profile Description' defaultValue={user.description} />
                                </div>
                            </ThemedProfileGrid>

                        </form>

                        <ThemedProfileGrid className="myprofile-grid-item myprofile-grid-2">
                            <div className="myprofs-nav">

                                <div className="myprofs-navitems">
                                    <button className={`profselbtn ${myprofselection === 'portfolio' ? 'profselactive' : 'profselinactive'}`} onClick={() => handleProfSelection('portfolio')}><span className='profnav-port'>Portfolio</span></button>
                                    <button className={`profselbtn ${myprofselection === 'experience' ? 'profselactive' : 'profselinactive'}`} onClick={() => handleProfSelection('experience')}><span className='profnav-exp'>Experience</span></button>
                                    <button className={`profselbtn ${myprofselection === 'education' ? 'profselactive' : 'profselinactive'}`} onClick={() => handleProfSelection('education')}><span className='profnav-edu'>Education</span></button>
                                    <button className={`profselbtn ${myprofselection === 'certifications' ? 'profselactive' : 'profselinactive'}`} onClick={() => handleProfSelection('certifications')}><span className='profnav-cert'>Certifications</span></button>
                                </div>

                                <div className="myprofs-navfilter">
                                    <button className='profaddbtn' onClick={openPopup}><i class="fa-solid fa-plus"></i></button>
                                    {isPopupOpen && myprofselection === 'portfolio' && <AddPortfolio onClose={closePopup} id={id} fetchUser={fetchUser} />}
                                    {isPopupOpen && myprofselection === 'experience' && <AddExperience onClose={closePopup} id={id} fetchUser={fetchUser} />}
                                    {isPopupOpen && myprofselection === 'education' && <AddEducation onClose={closePopup} id={id} fetchUser={fetchUser} />}
                                    {isPopupOpen && myprofselection === 'certifications' && <AddCertifications onClose={closePopup} id={id} fetchUser={fetchUser} />}
                                </div>
                            </div>
                            <hr />
                            {myprofselection === 'portfolio' && (
                                <MyProfilePortfolio portfolioTitlesArray={portfolioTitlesArray} portfoliohyperlinksArray={portfoliohyperlinksArray} portfolioIDArray={portfolioIDArray} handlePortfolioDelete={handlePortfolioDelete} PortfolioImageLinksArray={PortfolioImageLinksArray} />
                            )}
                            {myprofselection === 'experience' && (
                                <MyProfileExperience expdetails={expdetails} handleExperienceDelete={handleExperienceDelete} />
                            )}
                            {myprofselection === 'education' && (
                                <MyProfileEducation edudetails={edudetails} handleEducationDelete={handleEducationDelete} />
                            )}
                            {myprofselection === 'certifications' && (
                                <MyProfileCertification certdetails={certdetails} handleCertificationDelete={handleCertificationDelete} />
                            )}
                        </ThemedProfileGrid >
                    </div>

                    <div className="myprofile-column2">
                        <ThemedProfileGrid className="myprofile-grid-item myprofile-grid-6">
                            <h3 style={{ fontWeight: '400', marginBottom: '-0.4rem' }}>My Projects</h3>
                            <br />
                            <div className='myprofileproj'>
                                {user.project_id && user.project_title && user.project_id.split(',').map((projectId, index) => (
                                    <div key={projectId} className='myprofileproj'>
                                        <p className='myprofileprojtitle'>{user.project_title.split(',')[index]}</p>
                                        <a href={`/project/${projectId}`} className='myprofileprojbtn'>View &gt;</a>
                                    </div>
                                ))}
                                {user.project_id < 1 && (
                                    <p>No Projects Added</p>
                                )}
                            </div>

                        </ThemedProfileGrid >

                        <ThemedProfileGrid className="myprofile-grid-item myprofile-grid-7">
                            <div style={{ marginBottom: '1rem' }}>
                                <h3>Top Skills</h3>
                            </div>
                            <form onSubmit={handleSkillSubmit}>
                                <div className='addskill'>
                                    <SkillsDropdown
                                        onSelect={(skillName) => {
                                            handleSkillSubmit({
                                                preventDefault: () => { },
                                                target: { newskill: { value: skillName } }
                                            });
                                        }}
                                        placeholder="Select from list or add custom skill"
                                    />
                                </div>
                            </form>
                            {topSkillsArray.length > 0 ? (
                                <div>
                                    <div className='profskillstags'>
                                        {topSkillsArray.map((skill, index) => (
                                            <div className='profskillstag'>
                                                <span key={index} style={{ color: 'white' }} href="/">{skill.trim()}</span>
                                                <button onClick={() => handleDeleteSkill(skill.trim())} className='skilldelete'><i class="fa-solid fa-xmark"></i></button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <p>No Skills Added</p>
                                </div>
                            )}
                        </ThemedProfileGrid >
                    </div>
                </div>
            ) : (
                <div className="deny-grid-container">
                    <div className="denycontainer">
                        <div className="denytitle">
                            <h2 style={{ fontWeight: '400', textAlign: 'center', marginBottom: '1rem' }}>Unauthorised Access.</h2>
                        </div >
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyProfileContent;
